export const constants = {
  MONTH_DROPDOWN_PICKER_LABEL: 'Select Months',
  FILTER_THE_MONTHS_PLACEHOLDER: 'Filter the months by typing here',
  MONTH_RANGE_SEPARATOR_TEXT: '→',
  INVALID_START_END_YEAR_COMBINATION: 'Invalid Start & End Year combination',
  INVALID_START_END_MONTH_COMBINATION: 'Invalid Start & End Month combination',
  VISIBILITY_HIDDEN_CLASS: 'visibility-hidden',
  VISIBILITY_SHOWN_CLASS: 'visibility-shown',
  HIDE_HTML_ELEMENT: 'hide-me',
  SELECTED_MONTH_BACKGROUND_COLOR: 'selected-month-background-color',
  HOVERED_MONTH_BACKGROUND_COLOR: 'hovered-month-background-color',
  MONTHS_WITH_FULL_NAMES: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  MONTHS_WITH_SHORT_NAMES: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ]
}
